import { buttonShape, buttonType } from '@/constants';

export const PodiumProProps = {
    darkMode: {
        type: Boolean,
        default: false,
    },
    isPartnerRowZeta: {
        type: Boolean,
        default: false,
    },
    borderColor: {
        type: String,
        default: '#FF9900',
    },
    flagColor: {
        type: String,
        default: '#FF6600',
    },
    flagTextColor: {
        type: String,
        default: '#FFFFFF',
    },
    scoreTextSize: {
        type: String,
        default: '24px',
    },
    scoreTextColor: {
        type: String,
        default: '#333',
    },
    scoreBgColor: {
        type: String,
        default: '#FF6600',
    },
    scoreNumberTextColor: {
        type: String,
        default: '#FFFFFF',
    },
    textColor: {
        type: String,
        default: '#333',
    },
    buttonType: {
        type: String,
        default: buttonType.outline,
    },
    buttonShape: {
        type: String,
        default: buttonShape.oval,
    },
    buttonColor: {
        type: String,
        default: '#FF9900',
    },
    buttonTextColor: {
        type: String,
        default: '#333',
    },
    ratingIconType: {
        type: String,
        default: 'star',
    },
    ratingIconSize: {
        type: String,
        default: '14px',
    },
    ratingIconColor: {
        type: String,
        default: '#F3B42C',
    },
    ratingIconInactiveColor: {
        type: String,
        default: '#D8D8D8',
    },
};
